import request from '@/utils/request';
// import link from '../mock/link';

export function getModule(code) {
  const data = {
    m: 'modules',
    catalogid: code,
  };
  return request({
    // url: '/api',
    url: '//api.mulubao.com/mulubao_json.php',
    method: 'post',
    data,
  });
}

export function getPages(code) {
  const data = {
    m: 'pages',
    catalogid: code,
  };
  return request({
    url: '//api.mulubao.com/mulubao_json.php',
    // url: '/api',
    method: 'post',
    data,
  });
}

export function getNewsTicker(code) {
  const data = {
    m: 'newsticker',
    catalogid: code,
  };
  return request({
    // url: '/api',
    url: '//api.mulubao.com/mulubao_json.php',
    method: 'post',
    data,
  });
}

export function getOldMagazine(code) {
  const data = {
    m: 'magazine',
    catalogid: code,
  };
  return request({
    // url: '/api',
    url: '//api.mulubao.com/mulubao_json.php',
    method: 'post',
    data,
  });
}

export function getSearch(code, keyword, mode) {
  const method = mode ? 'searchThisPaper' : 'searchThisPaper';
  console.log(method);
  const data = {
    m: method,
    catalogid: code,
    keyword,
  };
  return request({
    // url: '/api',
    url: '//api.mulubao.com/mulubao_json.php',
    method: 'post',
    data,
  });
}

export function getLinks(code) {
  const data = {
    m: 'links',
    catalogid: code,
  };
  return request({
    // url: '/api',
    url: '//api.mulubao.com/mulubao_json.php',
    method: 'post',
    data,
  });
}

export function getRightAds(code) {
  const data = {
    m: 'image',
    catalogid: code,
  };
  return request({
    // url: '/api',
    url: '//api.mulubao.com/mulubao_json.php',
    method: 'post',
    data,
  });
}

export function getCategoryJson(path) {
  return request({
    url: `//static.mulubao.com/${path}`,
    // url: `/test/${path}`,
    method: 'get',
    withCredentials: true,
  });
}

// 获取分类模板设置
export function getCategory(code) {
  const data = {
    m: 'ringier_custom',
    category_id: code,
  };
  return request({
    url: `//api.mulubao.com/mulubao_json_html5.php?m=ringier_custom&category_id=${code}`,
    method: 'get',
    data,
  });
}
